import React, { useEffect, useState } from "react";
import "./FeeReceipt1.css";
import { imgBaseUrl } from "../../api/api";
import { convertNumberToWords } from "../master/Master";
import { formatToDate } from "../master/FormatToDateTime";

export default function FeeReceipt1({ data }) {
  const [setting, setSetting] = useState({});
  const [printBothCopies, setPrintBothCopies] = useState(false);

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);

  return (
    <>
      <style>
        {`
        .a4-page-receipt::before{
            background-image: url(${imgBaseUrl + setting?.logo_img});
        }
          `}
      </style>

      <div className="mb-3">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="printBothCopies"
            checked={printBothCopies}
            onChange={(e) => setPrintBothCopies(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="printBothCopies">
            Generate Office Copy
          </label>
        </div>
      </div>

      <div id="PrintDiv" className="a4-page-receipt-main p-3 mb-3">
        {/* {["Student"]?.map((type, k) => ( */}
        {(printBothCopies
          ? ["Student", "Office"]
          : ["Student"]
        ).map((type, k) => (
          <div className="a4-page-receipt p-3 mb-6" key={k}>
            <div className="row g-1 overflow-hidden">
              {setting?.receipt_header_logo ? (
                <div className="col-12 text-center">
                  <img
                    src={imgBaseUrl + setting?.receipt_header_logo}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </div>
              ) : (
                <>
                  <div className="col-12">
                    <div className="d-flex align-items-center justify-content-center">
                      <img
                        src={imgBaseUrl + setting?.logo_img}
                        style={{ width: "200px", height: "100px", objectFit: "contain" }}
                        alt=""
                      />
                      <div className="text-center text-dark">
                        <h3 className="m-0 ri-26px fw-bold">{setting?.name}</h3>
                        <h6 className="m-0">
                          {setting?.village} {setting?.district}{" "}
                          {setting?.state} {setting?.pin_code}
                        </h6>
                        <p className="m-0">
                          Mobile No : {setting?.mobile}{" "}
                          {setting?.secondary_mobile}{" "}
                        </p>
                        <p className="m-0">Email : {setting?.email}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 border-top"></div>
                  <div className="col-12">
                    <div className="row align-items-center text-center">
                      <div className="col-4">
                        <h5 className="text-primary m-0">Student Details</h5>
                      </div>
                      <div className="col-4">
                        <span className="badge bg-primary fs-6">
                          Fee Receipt
                        </span>
                      </div>
                      <div className="col-4">
                        <h5 className="text-primary m-0">{type} Copy</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 border-bottom"></div>
                </>
              )}

              <div className="col-12">
                <div className="row me-0 pe-0 student-details">
                  <div className="col-2">Receipt No</div>
                  <div className="col-1">:</div>
                  <div className="col-3">
                    {data?.receipt_no ?? `REP-${data?.id}`}
                  </div>
                  <div className="col-2">Date</div>
                  <div className="col-1">:</div>
                  <div className="col-3">
                    {formatToDate(data?.payment_date)}
                  </div>

                  <div className="col-2">Student Name</div>
                  <div className="col-1">:</div>
                  <div className="col-3">{data?.student?.name ?? data?.student?.student_name}</div>
                  <div className="col-2">Registration No</div>
                  <div className="col-1">:</div>
                  <div className="col-3">{data?.student?.registration_no}</div>

                  <div className="col-2">Father`s Name</div>
                  <div className="col-1">:</div>
                  <div className="col-3">{data?.student?.father_name}</div>
                  <div className="col-2">Mobile No</div>
                  <div className="col-1">:</div>
                  <div className="col-3"> {data?.student?.mobile ?? data?.student?.phone}</div>
                  {data?.modules?.length > 0 && data.modules?.[0]?.batch_name ? (
                    <>
                      <div className="col-2">Course Name</div>
                      <div className="col-1">:</div>
                      <div className="col-3">
                        {[...new Set(
                          data.modules
                            .map((module) => module?.course_name)
                            .filter(Boolean)
                        )].join(", ")}
                      </div>

                      <div className="col-2">Batch Name</div>
                      <div className="col-1">:</div>
                      <div className="col-3">
                        {[...new Set(
                          data.modules
                            .map((module) => module?.batch_name)
                            .filter(Boolean)
                        )].join(", ")}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-2">Course Name</div>
                      <div className="col-1">:</div>
                      <div className="col-3">
                        {data?.student?.latest_course_and_fee?.course?.title || "-"}
                      </div>

                      <div className="col-2">Batch Name</div>
                      <div className="col-1">:</div>
                      <div className="col-3">
                        {data?.student?.latest_course_and_fee?.batch?.title || "-"}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="col-12">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Fee Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.modules?.map((module, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{module?.type}</td>
                        <td>₹{Number(module?.amount || 0)?.toFixed(2)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td></td>
                      <td className="text-end">Total</td>
                      <td>₹{data?.amount || 0}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-12">
                <div className="row me-0 pe-0">
                  <div className="col-3">Amount in Words</div>
                  <div className="col-1">:</div>
                  <div className="col-8">
                    {convertNumberToWords(data?.amount ?? 0)} Rupees
                  </div>
                  {data?.remark && (
                    <>
                      <div className="col-3">Remark</div>
                      <div className="col-1">:</div>
                      <div className="col-8">{data?.remark}</div>
                    </>
                  )}

                  <div className="col-3">Payment Method</div>
                  <div className="col-1">:</div>
                  <div className="col-8">{data?.payment_method}</div>

                  {data?.payment_method === "Online" && (
                    <>
                      <div className="col-3">Account No</div>
                      <div className="col-1">:</div>
                      <div className="col-8">{data?.account_no}</div>
                    </>
                  )}

                  {data?.transaction_no && (
                    <>
                      <div className="col-3">Transaction No</div>
                      <div className="col-1">:</div>
                      <div className="col-8">{data?.transaction_no}</div>
                    </>
                  )}

                  {data?.modules?.length > 0 && data.modules?.[0]?.session ? (
                    <>
                      <div className="col-3">Session</div>
                      <div className="col-1">:</div>
                      <div className="col-8">
                        {[...new Set(
                          data.modules
                            .map((module) => module?.session)
                            .filter(Boolean)
                        )].join(", ")}
                      </div>
                    </>
                  ) : (
                    data?.student?.latest_course_and_fee?.session_year?.session && (
                      <>
                        <div className="col-3">Session</div>
                        <div className="col-1">:</div>
                        <div className="col-8">
                          {data?.student?.latest_course_and_fee?.session_year?.session}
                        </div>
                      </>
                    )
                  )}
                  <div className="col-12 text-end">
                    {setting?.auto_signature === "Yes" &&
                      setting?.signature && (
                        <img
                          src={imgBaseUrl + setting.signature}
                          alt="Signature"
                          style={{
                            width: "100px",
                            height: "50px",
                            objectFit: "contain",
                            display: "block",
                            marginLeft: "auto",
                            marginBottom: "2px",
                          }}
                        />
                      )}

                    Auth. Signature
                  </div>                  <div className="col-12 text-center text-danger">
                    Fees once paid are non-refundable.
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
